import React from 'react'
import SpaceBookingBody from '../../../components/AdminDashboard/SpaceBooking/SpaceBookingBody'
import SideNav from '../../../layouts/AdminDashboard/SideNav'

const SpaceBooking = () => {
  return (
    <div className='flex justify-end mobile:justify-start mobile:w-screen mobile:flex-col min-h-screen w-full mobile:bg-[#E5E5E5]'>

        {/* Side nav */}
        <SideNav />

        {/* Body section */}
        <SpaceBookingBody />
    </div>
  )
}

export default SpaceBooking